import React from "react";
import { useSelector } from "react-redux";
import { savePaginationData } from "../../../../redux/features/globalDatagridSlice";
import GlobalDeleteDialog from "../../../../components/mui/Dialogue/GlobalDeleteDialog";
import { deleteSale, getSale } from "../../../../redux/features/assetManagementSlice";

const DeleteRequirement = ({
  dispatchParams,
  saleId,
  disable,
  isNotRequestRaiser
}) => {
  const { loading } = useSelector((store) => store.assetmanagement);
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  return (
    <GlobalDeleteDialog
      disabled={disable || isNotRequestRaiser}
      title={"Delete"}
      deleteNote={"Are you sure? you want to delete this Request..?"}
      api={deleteSale(saleId)}
      upDateCall={getSale(dispatchParams)}
      updatePaginationCall={savePaginationData({
        ...paginationData,
        openAnchor: false,
      })}
      loading={loading}
    />
  );
};

export default DeleteRequirement;
